import { useEffect, useState } from "react";
import { ProfileType } from "../../options-table/types/ProfileType";
import {
    usePortfolioSelection,
    usePortfolioManagement,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { Stack } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { ToolsPanelToggleButton } from "../../../screens/positions-and-orders/controls";

export function BalanceProfilesSelector() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();
    
    const [isCurrentBalanceVisible, setIsCurrentBalanceVisible] = useState<boolean>(false);
    const [isCustomBalanceVisible, setIsCustomBalanceVisible] = useState<boolean>(false);
    const [isExpirationBalanceVisible, setIsExpirationBalanceVisible] = useState<boolean>(false);

    useEffect(() => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            setIsCurrentBalanceVisible(
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .some(x => x === ProfileType.Current));

            setIsCustomBalanceVisible(
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .some(x => x === ProfileType.Custom));

            setIsExpirationBalanceVisible(
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .some(x => x === ProfileType.Expiration));
        }
    }, [selectedPortfolio]);
    
    const onChangeHandle = async (profileType: ProfileType): Promise<void> => {
        if (selectedPortfolio === null || selectedPortfolio.portfolioSettings === null)
            return;
        
        let isSwitchOn: boolean = false;
        
        switch(profileType) {
            case ProfileType.Current:
                isSwitchOn = isCurrentBalanceVisible;
                setIsCurrentBalanceVisible(!isCurrentBalanceVisible);
                break;

            case ProfileType.Custom:
                isSwitchOn = isCustomBalanceVisible;
                setIsCustomBalanceVisible(!isCustomBalanceVisible);
                break;

            case ProfileType.Expiration:
                isSwitchOn = isExpirationBalanceVisible;
                setIsExpirationBalanceVisible(!isExpirationBalanceVisible);
                break;
        }

        if (isSwitchOn) {
            selectedPortfolio.portfolioSettings.selectedProfileTypes =
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .filter(x => x !== profileType);
        } else {
            selectedPortfolio.portfolioSettings.selectedProfileTypes.push(profileType);
        }
        
        updateSelectedPortfolio();
        saveSelectedPortfolio();
    }
    
    return (
        <Stack direction="row" spacing={0.5}>
            <ToolsPanelToggleButton
                isActivated={isCurrentBalanceVisible}
                setIsActivated={() => { void onChangeHandle(ProfileType.Current); }}
                tooltipTextWhenActivated="Hide current balance"
                tooltipTextWhenDeactivated="Show current balance"
            >
                <MoreHorizIcon sx={{
                    height: '18px',
                    width: '18px',
                }}/>
            </ToolsPanelToggleButton>
            <ToolsPanelToggleButton
                isActivated={isCustomBalanceVisible}
                setIsActivated={() => { void onChangeHandle(ProfileType.Custom); }}
                tooltipTextWhenActivated="Hide custom balance"
                tooltipTextWhenDeactivated="Show custom balance"
            >
                <LinearScaleIcon sx={{
                    height: '18px',
                    width: '18px',
                }}/>
            </ToolsPanelToggleButton>
            <ToolsPanelToggleButton
                isActivated={isExpirationBalanceVisible}
                setIsActivated={() => { void onChangeHandle(ProfileType.Expiration); }}
                tooltipTextWhenActivated="Hide expiration balance"
                tooltipTextWhenDeactivated="Show expiration balance"
            >
                <HorizontalRuleIcon sx={{
                    height: '18px',
                    width: '18px',
                }}/>
            </ToolsPanelToggleButton>
        </Stack>
    );
}

